export default function Footer() {
  return (
    <footer className="py-6 sm:py-8 border-t bg-white">
      <div className="container-max text-sm text-brand-blue/70 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-2">
        <div className="text-center md:text-left">© {new Date().getFullYear()} PRUSHA TECHNOLOGY PVT LTD. All rights reserved.</div>
        <div className="flex gap-4 md:gap-6">
          <a href="#plans" className="hover:text-[color:var(--brand-orange)] transition-colors">Plans</a>
          <a href="#features" className="hover:text-[color:var(--brand-orange)] transition-colors">Features</a>
          <a href="#contact" className="hover:text-[color:var(--brand-orange)] transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  );
}

